var React = require('react');

function Eye (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"#9F9EAD","strokeWidth":"2","fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round"},[React.createElement("path",{"d":"M12 6C6.167 6 2 12 2 12s4.167 6 10 6c5.834 0 10-6 10-6s-4.166-6-10-6z","key":0}),React.createElement("path",{"d":"M12 8.407c-1.872 0-3.39 1.534-3.39 3.426 0 1.891 1.518 3.425 3.39 3.425s3.39-1.534 3.39-3.425c0-1.892-1.518-3.426-3.39-3.426z","key":1})]));
}

Eye.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Eye;

Eye.default = Eye;
